import { Box, Chip, Typography } from "@mui/material";
import { TeamId } from "../interface/GameTypes";

const SUIT_SYMBOLS: Record<string, string> = {
  Spades: "♠",
  Hearts: "♥",
  Diamonds: "♦",
  Clubs: "♣",
};

const SUIT_COLORS: Record<string, string> = {
  Spades: "#e0e0e0",
  Hearts: "#f44336",
  Diamonds: "#f44336",
  Clubs: "#e0e0e0",
};

interface Props {
  suit: string;
  callerTeam: TeamId;
  compact?: boolean;
}

export const TrumpIndicator = ({ suit, callerTeam, compact }: Props) => {
  const symbol = SUIT_SYMBOLS[suit] ?? suit;
  const color = SUIT_COLORS[suit] ?? "#fff";
  const teamColor = callerTeam === TeamId.A ? "#4caf50" : "#ffc107";

  if (compact) {
    return (
      <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        backgroundColor: "rgba(0,0,0,0.75)",
        border: `2px solid ${color}`,
        borderRadius: 2,
        px: 1.1,
        py: 0.45,
        width: "100%",
        minHeight: 48,
        boxSizing: "border-box",
      }}>
        <Typography sx={{ color, fontSize: "1.4rem", lineHeight: 1 }}>
          {symbol}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.15 }}>
          <Typography sx={{ color: "#fff", fontSize: "0.8rem", fontWeight: "bold", lineHeight: 1.1 }}>
            {suit}
          </Typography>
          <Typography sx={{ color: teamColor, fontSize: "0.6rem", fontWeight: "bold", lineHeight: 1 }}>
            Team {callerTeam} called
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        backgroundColor: "rgba(0,0,0,0.82)",
        border: `2px solid ${color}`,
        borderRadius: 3,
        px: 2.5,
        py: 1.5,
        minWidth: 90,
      }}
    >
      <Typography sx={{ color, fontSize: "3.5rem", lineHeight: 1 }}>
        {symbol}
      </Typography>
      <Typography variant="subtitle2" sx={{ color, fontWeight: "bold", letterSpacing: 1 }}>
        {suit}
      </Typography>
      <Chip
        label={`Team ${callerTeam} called`}
        size="small"
        color={callerTeam === TeamId.A ? "success" : "warning"}
        sx={{ fontSize: "0.65rem", mt: 0.5 }}
      />
    </Box>
  );
};
